export default __webpack_public_path__ + "static/Dreamaker_logo-29aa98dd52e28a4ce96526d47a6225d4.png";